import {ROOT_URL} from '../redux/constants';
import {TokenManager} from "./TokenManager";

let axios = require('axios');
let tokenManager = new TokenManager();

export const TRACKER = "trackers";
export const AGRISMART = "agrismart";
export const AGRISMART2 = "agrismart2";
export const PARCELS = "parcels";
export const ALERTS = "alerts";
export const LOGIN_URL = "users/login";
export const REFRESH_TOKEN = "users/refresh";
export const USERS = "users";
export const SIGNUP = "users/sign-up";
export const PROJECTS = "projects";
export const DEVICES = "devices";
export const SWITCH = "switch";
export const BADGE = "badge";
export const BUILDING = "buildings";
export const GEOFENCING = "geofencing";
export const PROJECT = "project"

export class Client {

	get = (url, config = {elem: "", params:{}, header: {} }) => {
		return axios.get(this.getUrl(url, config.elem), this.getConfig(config));
	};

	post = (url, config = {elem: "", body: {}, params:{}, header: {} }) => {
		return axios.post(this.getUrl(url, config.elem), config.body, this.getConfig(config));
	};

	update = (url, config = {elem: "", body: {}, params:{}, header: {} }) => {
		return axios.put(this.getUrl(url, config.elem), config.body, this.getConfig(config));
	};

	delete = (url, config = {elem: "", body: {}, params:{}, header: {} }) => {
		return axios.delete(this.getUrl(url, config.elem), this.getConfig(config));
	};

	getConfig = ({params = {}, headers= {}}) => {
		let token = tokenManager.get();
		if(token) headers['Authorization'] = `Bearer ${token}`;
		return {
			params: params,
			headers
		}
	};

	getUrl = (url, elem) => elem?`${ROOT_URL}${url}/${elem}`:`${ROOT_URL}${url}`
}

export function get(url, config = {elem: "", params: {}, header: {}}) {
	return axios.get(getUrl(url, config.elem), getConfig(config)).then(({data}) => data);
}

export function post(url, config = {elem: "", body: {}, params: {}, header: {}}) {
	return axios.post(getUrl(url, config.elem), config.body, getConfig(config));
}

export function put(url, config = {elem: "", body: {}, params: {}, header: {}}) {
	return axios.put(getUrl(url, config.elem), config.body, getConfig(config));
}

export function deleteElem(url, config = {elem: "", body: {}, params: {}, header: {}}) {
	return axios.delete(getUrl(url, config.elem), getConfig(config));
}

export function download(url) {
	return axios.get(getUrl(url), {responseType: 'blob', ...getConfig({})});
}

export function getErrorMessage(e) {
	let error = "Unknown error";
	if (e.response) {
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx
		error = e.response.data.message || e.response.data.error;
	} else {
		// Something happened in setting up the request that triggered an Error
		error = e.message || e.error;
	}
	console.log(error);
	return error;
}

function getConfig({params = {}, headers = {}}) {
	let token = tokenManager.get();
	if (token) headers['Authorization'] = `Bearer ${token}`;
	return {
		params: params,
		headers
	};
}

function getUrl(url, elem) {
	return elem ? `${ROOT_URL}${url}/${elem}` : `${ROOT_URL}${url}`;
}
